import { motion } from "framer-motion";
import ProjectCard from "../components/ProjectCard";

const Projects = () => {
  const works = [
    {
      title: "Aegis Cloud Sentinel",
      imgSrc: "/images/Project_0.png",
      tags: ["AWS", "Cloud Security", "Python", "FastAPI", "Gemini AI"],
      desc: "A Cloud Security Posture Management (CSPM) platform for AWS that automates security assessments across IAM, EC2, S3, CloudTrail, and VPC services. It detects security misconfigurations, calculates a weighted security posture score, generates professional audit reports, and includes a Gemini-powered assistant that explains findings and recommends remediation based on AWS security best practices.",
      projectLink: "https://github.com/perkyPearl/Aegis-Cloud-Sentinel-AI-Powered-AWS-Cloud-Security-Platform",
    },
    {
      title: "Memosac - Digital Heirloom Vault",
      imgSrc: "/images/Project_4.png",
      tags: ["React", "Express.js", "MongoDB", "AWS S3"],
      desc: "A secure platform for storing and preserving digital heirlooms such as photos, documents, and videos. Built with React, Express.js, MongoDB, and AWS S3, it provides secure authentication, scalable cloud storage, and an intuitive interface for managing and sharing important digital memories.",
      projectLink: "https://github.com/perkyPearl/Memosac",
    },
    {
      title: "Real-Time Soil Analysis",
      imgSrc: "/images/Project_3.png",
      tags: ["Python", "Arduino", "WebSockets", "Gemini AI"],
      desc: "A real-time monitoring dashboard that analyzes soil moisture and temperature using Arduino sensors. Live sensor data is streamed via WebSockets, while Gemini AI provides actionable recommendations to help farmers optimize irrigation and improve crop productivity.",
      projectLink: "https://github.com/perkyPearl/Real-Time-Soil-Analysis",
    },
    {
      title: "Desktop Notifier",
      imgSrc: "/images/Project_1.png",
      tags: ["Python", "Desktop App", "Automation"],
      desc: "A cross-platform desktop application that promotes healthy work habits by sending reminders for the 20-20-20 rule, hydration, and motivational quotes. Supports Windows and macOS with lightweight background notifications.",
      projectLink: "https://github.com/perkyPearl/Desktop-Notifier",
    },
    {
      title: "JS Weather Application",
      imgSrc: "/images/Project_2.png",
      tags: ["JavaScript", "API", "Weather"],
      desc: "A JavaScript-based weather application that provides real-time weather conditions and forecasts using public weather APIs through a clean and responsive interface.",
      projectLink: "https://js-weather-application.vercel.app/",
    },
    {
      title: "File Organizer",
      imgSrc: "/images/Project_5.png",
      tags: ["Python", "Automation", "Productivity"],
      desc: "A Python automation tool that organizes files by type, renames them automatically, and keeps directories clean, improving file management and productivity.",
      projectLink: "https://github.com/perkyPearl/File-Organizer",
    },
  ];

  return (
    <section id="projects" className="section">
      <div className="container">
        <div className="headline-2 mb-8">My Projects</div>
        <div className="space-y-8">
          {works.map(({ imgSrc, title, desc, tags, projectLink }, key) => (
            <motion.div
              key={key}
              initial={{ opacity: 0, y: 100 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{
                duration: 0.6,
                ease: "easeOut",
              }}
              viewport={{ once: true, amount: 0.5 }}
              className="w-full"
            >
              <ProjectCard
                title={title}
                tags={tags}
                desc={desc}
                imgSrc={imgSrc}
                projectLink={projectLink}
                classes="w-full"
              />
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Projects;